import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './app/App';
import '@aurora-pvi/design-system/tokens.css';
// The Aurora Glass material layer. Scoped under [data-theme-v2='glass'], so it
// costs nothing on the classic routes and needs no lazy loading.
import '@aurora-pvi/design-system/glass.css';
import './styles.css';

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root was not found in index.html');

ReactDOM.createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
